export default "__VITE_ASSET__3ll_E2TX__"